export default __webpack_public_path__ + "2cfe2628b396169eb35e3d166d6fdaee.svg";